import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/vcicon.svg'
import _imports_1 from '@/assets/icons/openlistdetails.svg'
import _imports_2 from '@/assets/icons/pagefirstenabled.svg'
import _imports_3 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_4 from '@/assets/icons/pagelastenabled.svg'
import _imports_5 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = { class: "celldiv" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cellimage",
  alt: "vciconimg",
  title: "vciconimg"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"25px"},
  alt: "listdetailsimg",
  title: "listdetialsimg"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "usermodalpagingdiv"
}
const _hoisted_5 = { class: "pagelabel" }
const _hoisted_6 = {
  key: 0,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "pagefirstenabledimg",
  title: "pagefirstenabledimg"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "pagefirstdisabledimg",
  title: "pagefirstdisabledimg"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "pagelastenabledimg",
  title: "pagelastenabledimg"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_5,
  style: {"width":"20px"},
  alt: "pagelastdisabledimg",
  title: "pagelastdisabledimg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      id: "companysubscriptionstable",
      data: _ctx.subscriptionList,
      style: {"width":"100%"},
      "max-height": "600px",
      "scrollbar-always-on": "",
      "header-cell-style": _ctx.headerstyle,
      "header-row-style": _ctx.headerrow,
      "row-style": _ctx.rowdatastyle,
      "empty-text": "No credential-based products available"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Product Name",
          prop: "productName"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", {
                class: _normalizeClass(props.row.expirationCount > 0 ? 'expirationlabel' : '')
              }, _toDisplayString(props.row.productName), 3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Version"
        }, {
          default: _withCtx((props) => [
            _createTextVNode(_toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Product Seats",
          align: "center"
        }, {
          default: _withCtx((props) => [
            _createTextVNode(_toDisplayString(props.row.seatsUsed) + "/" + _toDisplayString(props.row.seats), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Add-on",
          align: "center",
          prop: "addOns"
        }, {
          default: _withCtx((props) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.productName), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Add-on Seats",
          align: "center"
        }, {
          default: _withCtx((props) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.seatsUsed) + "/" + _toDisplayString(addon.seats), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "",
          width: "120"
        }, {
          default: _withCtx((subcription) => [
            _createVNode(_component_el_button, {
              onClick: ($event: any) => (_ctx.viewDetails(subcription.row)),
              link: "",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "header-row-style", "row-style"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentPage = 1)),
            id: "firstpage",
            disabled: _ctx.currentPage === 1
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.currentPage === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_pagination, {
            layout: "prev, next",
            total: _ctx.totalRowsCount,
            "page-size": 10,
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
          }, null, 8, ["total", "current-page"]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
            id: "lastpage",
            disabled: _ctx.currentPage === _ctx.totalPages
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.currentPage === _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}